// InvoicesList.js
// This is the client billing view - invoices list.

import React, { useCallback, useEffect, useReducer, useRef } from "react";
import { ActivityIndicator, Pressable, Text, View } from "react-native";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { stateReducer } from "components/helpers/stateReducer";
import { openSideScreen } from "components/Views/SideScreens/SideScreenLoader";
import format from "components/helpers/dataformats";

const InvoicesList = ({client_id}) => {
  const _theme = window.main.theme;

  if (!Number(client_id)) {
    return (
      <View id="client_invoices_invalid" style={{..._theme.tiles.outerContainer,alignItems:"center",paddingTop:50}}>
        <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.caution,fontSize:18,lineHeight:22}}>Client Details: Invalid client.</Text>
      </View>
    );
  }

  const [invoicesViewState, invoicesViewSetState] = useReducer(stateReducer, {
    invoices: [],
    invoicesLoading: true,  // ⬅ Default TRUE for iniital 'loading' state.
  });
  const _invoicesId = useRef(0);

  const initialDataLoad = useCallback(async () => {
    if (!!Number(_invoicesId.current)) {
      return false;
    }
    _invoicesId.current = client_id;
    const _stateProps = [
      { key: "invoicesLoading", type: "boolean", invoicesLoading: false }
    ];
    try {
      const [_invoices] = await Promise.all([
        window.main.axios.get(window.main.api.getClientInvoices.replace("{client_id}",client_id)),
      ]);
      if (!_invoices || !_invoices.data || !Array.isArray(_invoices.data)) {
        throw _invoices;
      }
      _stateProps.push({ key: "invoices", type: "array", invoices: _invoices.data });
      // Update all states at once:
      invoicesViewSetState(_stateProps);
    } catch (err) {
      console.log("InvoicesList > Error:", err);
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      invoicesViewSetState(_stateProps);
    }
  }, []);

  useEffect(() => {
    initialDataLoad();
  }, []);  // ⬅ Trigger only once on initial page load.

  if (!invoicesViewState.invoicesLoading && (!invoicesViewState.invoices || !Array.isArray(invoicesViewState.invoices))) {
    return (
      <View id="client_details_error" style={{..._theme.tiles.outerContainer,alignItems:"center",paddingTop:50}}>
        <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.caution,fontSize:18,lineHeight:22}}>Client Billing failed to load.</Text>
      </View>
    );
  }

  return (
    <View id="client_details__sidescreen" style={_theme.tiles.outerContainer}>

      <View id="client_invoices" style={_theme.tileRowNested}>
        <Text style={_theme.tiles.sectionHeaderTitle}>Invoices</Text>
        {(!invoicesViewState.invoices || !invoicesViewState.invoices.length) &&
          <View id="client_invoices_row" style={{..._theme.tiles.fieldRow,flexDirection:"column",alignSelf:"stretch"}}>
            <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.mode.placeholderTextColor,fontStyle:"italic",fontSize:14,lineHeight:18}}>No invoices.</Text>
          </View>
        }
        {invoicesViewState.invoices.map((invoiceObj)=>{
          return (
            <InvoiceRow key={"invoiceObj_"+invoiceObj.id} invoiceObj={invoiceObj} />
          );
        })}
      </View>

      {!window.main.lib.getLoadingState() && !!invoicesViewState.invoicesLoading &&
        // <View style={{zIndex:99999, backgroundColor:"rgba(255,255,255,0.7)", top:0, left:0, bottom:0, right:0, position:(window.main.platform_os==="web"?"fixed":"absolute")}}>
        <View style={{zIndex:99999,backgroundColor:"rgba(255,255,255,0.7)",top:0,left:0,bottom:0,right:0,position:"absolute"}}>
          <ActivityIndicator size="large" color={_theme.colors.mode.base} style={{marginTop:20}} />
        </View>
      }

    </View>
  );

};

const InvoiceRow = ({invoiceObj})=>{
  const _theme = window.main.theme;
  if (!invoiceObj || !Number(invoiceObj.id)) {
    return null;
  }
  const openPatientSideScreen = ()=>{ openSideScreen("invoice", {client_id:invoiceObj.client_id, invoice_id:invoiceObj.id}); };
  return (
    <Pressable id={"client_invoices_row_"+invoiceObj.id} onPress={openPatientSideScreen} style={{..._theme.tiles.fieldRow,flexDirection:"column",alignSelf:"stretch"}}>
      <Text style={{..._theme.tiles.fieldRowLabel,flexGrow:1,flexBasis:"none",flexGrow:0,flexShrink:1,fontSize:16}}>
        {invoiceObj.description}
      </Text>
      <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",paddingTop:5}}>
        {format.dollarFormat(invoiceObj.total)} – {window.main.lib.dateTimeFormat(invoiceObj.created_date.replace(/Z$/,""))} ({invoiceObj.status})
      </Text>
    </Pressable>
  );
};

// Exports

const config = {
  key: "billing",
  title: "Billing",
  view: InvoicesList,
  menu: "sidescreen",
  iconSource: "fa",
  icon: faUser,
};

export default InvoicesList;
export {
  config,
  InvoiceRow,
};
